import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      // sempre mostra sucesso pra não revelar cadastro
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-cuidar py-16 md:py-24 max-w-lg">
      <Link to="/entrar" className="inline-flex items-center gap-1.5 text-sm text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))]" data-testid="forgot-back-link">
        <ArrowLeft className="h-4 w-4" /> Voltar ao login
      </Link>
      <div className="mt-6 surface p-8">
        <div className="text-xs font-semibold tracking-widest uppercase text-[hsl(var(--secondary))]">Recuperar senha</div>
        <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-black leading-tight">Vamos te ajudar 🤗</h1>
        {sent ? (
          <div className="mt-6 p-5 rounded-2xl bg-[hsl(var(--primary))]/10 border border-[hsl(var(--primary))]/30" data-testid="forgot-sent-message">
            <div className="flex items-start gap-3">
              <Mail className="h-5 w-5 text-[hsl(var(--primary))] shrink-0 mt-0.5" />
              <div>
                <div className="font-semibold text-[hsl(var(--primary))]">E-mail enviado!</div>
                <p className="mt-1 text-sm text-[hsl(var(--foreground))] leading-relaxed">
                  Se <strong>{email}</strong> estiver cadastrado no Instituto Cuidar, você recebe em instantes um link para criar uma nova senha. O link vale por <strong>1 hora</strong>.
                </p>
                <p className="mt-3 text-xs text-[hsl(var(--muted-foreground))]">
                  Não achou? Confira a caixa de spam ou lixo eletrônico. Ainda com dúvida? Fala com a gente pelo WhatsApp — botão flutuante no rodapé.
                </p>
              </div>
            </div>
          </div>
        ) : (
          <>
            <p className="mt-3 text-[hsl(var(--muted-foreground))]">
              Informe o e-mail cadastrado no Instituto Cuidar. Enviaremos um link seguro pra você criar uma nova senha.
            </p>
            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">E-mail</Label>
                <Input
                  id="email" type="email" required autoComplete="email" data-testid="forgot-email-input"
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  className="mt-1.5 h-12 rounded-xl"
                  placeholder="voce@exemplo.com"
                />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                className="btn-pill w-full h-12 bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90">
                {loading ? "Enviando…" : "Enviar link de recuperação"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
